import script from "./SitiWebFisioterapia.vue?vue&type=script&setup=true&lang=js"
export * from "./SitiWebFisioterapia.vue?vue&type=script&setup=true&lang=js"

import "./SitiWebFisioterapia.vue?vue&type=style&index=0&id=35cd3376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35cd3376"]])

export default __exports__